module.exports = __webpack_public_path__ + "static/media/LUPIN.39c1d7a6.txt";